import { Button, IconButton } from '@mui/material';
import userPageIcon from '@assets/images/chat-images/user-page-full-screen-icon.svg';
import { ArrowLeftIcon, ArrowRightIcon } from '@components/icons/svg-icon.tsx';

const Group = ({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <div className="flex flex-col gap-4">
    <p className="font-semibold text-gray-700">{title}</p>
    <div className="flex flex-wrap items-center gap-4">{children}</div>
  </div>
);

function ButtonComponent() {
  return (
    <div className="flex flex-col gap-10">
      <h2 className="text-xl font-bold text-gray-800">Button</h2>

      <Group title="Variants">
        <Button variant="contained">Contained</Button>
        <Button variant="outlined">Outlined</Button>
        <Button variant="text">Text</Button>
      </Group>

      <Group title="With icons">
        <Button startIcon={<ArrowLeftIcon fill="white" />} variant="contained">
          Start icon
        </Button>
        <Button endIcon={<ArrowRightIcon fill="white" />} variant="contained">
          End icon
        </Button>
        <Button variant="outlined" startIcon={<ArrowLeftIcon />}>
          Start icon
        </Button>
        <Button variant="outlined" endIcon={<ArrowRightIcon />}>
          End icon
        </Button>
      </Group>

      <Group title="Sizes">
        <Button variant="contained" size="small">
          Small
        </Button>
        <Button variant="contained" size="medium">
          Medium
        </Button>
        <Button variant="contained" size="large">
          Large
        </Button>
      </Group>

      <Group title="Colors">
        <Button variant="contained" color="primary">
          Primary
        </Button>
        <Button variant="contained" color="secondary">
          Secondary
        </Button>
        <Button variant="contained" color="warning">
          Warning
        </Button>
        <Button variant="contained" color="error">
          Error
        </Button>
      </Group>

      <Group title="States">
        <Button variant="contained" loading>
          Loading
        </Button>
        <Button variant="outlined" loading>
          Loading
        </Button>
        <Button variant="contained" disabled>
          Disabled
        </Button>
        <Button variant="outlined" disabled>
          Disabled
        </Button>
      </Group>

      <Group title="Full width">
        <div className="w-full max-w-md">
          <Button variant="contained" fullWidth>
            Full width
          </Button>
        </div>
      </Group>

      <Group title="Icon buttons">
        <IconButton>
          <img src={userPageIcon} alt="Icon" />
        </IconButton>
        <IconButton className="icon-bordered">
          <img src={userPageIcon} alt="Icon" />
        </IconButton>
        <IconButton className="active-icon-bordered">
          <img src={userPageIcon} alt="Icon" />
        </IconButton>
        <IconButton disabled>
          <img src={userPageIcon} alt="Icon" />
        </IconButton>
      </Group>
    </div>
  );
}

export default ButtonComponent;
